import { Component, Input } from '@angular/core';
import { CurrencyPipe, NgIf } from '@angular/common';


@Component({
  selector: 'app-product-price',
  templateUrl: './product-price.component.html',
  styleUrls: ['./product-price.component.scss'],
  imports: [CurrencyPipe, NgIf],  
  standalone: true,
  
})
export class ProductPriceComponent {
  @Input() price: number;
  @Input() promotionalPrice?: number;
  @Input() pixPrice?: number;
  @Input() hasVariations: boolean = false;

  get hasPromo(): boolean {
    return (
      this.promotionalPrice != null &&
      this.promotionalPrice < this.price
    );
  }
  

  get discountPercent(): number | null {
    if (this.hasPromo) {
      return Math.round(((this.price - this.promotionalPrice) / this.price) * 100);
    }
    return null;
  }
}
